import { apiClient } from './api-client';

export interface ServiceTask {
  id: string;
  tenantId: string;
  code: string;
  name: string;
  description: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ServiceTaskListResponse {
  items: ServiceTask[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateServiceTaskPayload {
  code: string;
  name: string;
  description?: string;
}

export type UpdateServiceTaskPayload = Partial<CreateServiceTaskPayload> & { isActive?: boolean };

export const serviceTaskService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<ServiceTaskListResponse> =>
    apiClient.get<ServiceTaskListResponse>('/service-tasks', { params }).then((r) => r.data),

  listAll: (): Promise<ServiceTask[]> =>
    apiClient
      .get<ServiceTaskListResponse>('/service-tasks', { params: { pageSize: 100 } })
      .then((r) => r.data.items),

  create: (payload: CreateServiceTaskPayload): Promise<ServiceTask> =>
    apiClient.post<ServiceTask>('/service-tasks', payload).then((r) => r.data),

  update: (id: string, payload: UpdateServiceTaskPayload): Promise<ServiceTask> =>
    apiClient.patch<ServiceTask>(`/service-tasks/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/service-tasks/${id}`).then(() => undefined),
};
